// Adjustment Properties
export const LABEL = 'hs_label';
export const VALUE = 'hs_value';
export const TYPE = 'hs_type';
export const SORT_ORDER = 'hs_sort_order';

// Adjustment Type
export const FIXED = 'FIXED';
export const PERCENT = 'PERCENT';